import ContactCorrespondenceAddressResourceModel from '../../generated/types/model/resource/ContactCorrespondenceAddressResourceModel';

export default class ContactCorrespondenceAddressResourceViewModel extends ContactCorrespondenceAddressResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
